import React from 'react';

export default function VodacomLogo({ className }) {
  return (
    <section className={className}>
      <svg
        className="vodacom-logo"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M63.2166 31.6085C63.2166 49.0652 49.0651 63.2166 31.6083 63.2166C14.1515 63.2166 0 49.0652 0 31.6085C0 14.1514 14.1515 0 31.6083 0C49.0651 0 63.2166 14.1514 63.2166 31.6085Z"
          fill="#E60000"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.9671 49.7823C23.2898 49.8112 14.2622 42.3711 14.2228 30.4242C14.1965 22.5236 18.4393 14.9186 23.8627 10.4068C29.1526 6.00615 36.3996 3.18196 42.9721 3.16024C43.8181 3.15733 44.7032 3.22829 45.2447 3.41231C39.498 4.60973 34.9242 9.98278 34.9445 16.0784C34.9452 16.2799 34.9632 16.4953 34.9828 16.5956C44.5994 18.9485 48.965 24.7778 48.9917 32.8437C49.018 40.909 42.6797 49.7465 31.9671 49.7823Z"
          fill="white"
        />
      </svg>
    </section>
  );
}
